import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API_BASE_URL } from '../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { MatPaginator, MatDialog } from '@angular/material';
import { SalaryDialogComponent } from './salary-dialog/salary-dialog.component';
import { SalaryAdjustmentDialogComponent } from './salary-adjustment/salary-adjustment-dialog.component';
import { SalaryAdjustmentDayHourDialogComponent } from './salary-adjustment-day-hour/salary-adjustment-day-hour-dialog.component';
import { SalaryCsvDialogComponent } from './salary-csv-dialog/salary-csv-dialog.component';
import moment from 'moment';
import { StaffDetailDialogComponent } from '../staffs/staff-detail-dialog/staff-detail-dialog.component';

// 給与一覧カラム
const col1 = [
    { title: ' \n清掃員' },
    { title: '物件名' },
    { title: '勤務日数', payslip: true, class: 'top' },
    { title: '勤務時間' },
    { title: '勤務金額' },
    { title: '有休日数', payslip: true, class: 'top' },
    { title: '有休時間' },
    { title: '有休金額' },

    { title: '合計時間\n（勤務+有休）', payslip: true },
    { title: '合計金額\n（勤務+有休）', payslip: true },
    { title: '交通費', payslip: true },
    { title: 'エリア\nエリア詳細' },
    { title: '相違あり', class: 'red' },
    { title: '金額OK\n確認', class: 'blue-text' },
    { title: '（CSV）\nｲﾝﾎﾟｰﾄ用済\n手入力用済', class: 'col-csv' },
    { title: '' },
    { title: 'メモ\n過去半年分表示' }
  ];

// 承認待ち一覧カラム
const col2 = [
    { title: '清掃員' },
    { title: '物件' },
    { title: '勤務金額' },
    { title: '有休金額' },
    { title: '交通費' },
    { title: '申請理由' },
    { title: '申請者\r\n申請日' },
    { title: '' },
    { title: '' }
  ];

// 調整履歴一覧カラム
const col3 = [
    { title: '清掃員' },
    { title: '物件' },
    { title: '勤務金額' },
    { title: '有休金額' },
    { title: '交通費' },
    { title: '申請理由' },
    { title: '差戻理由' },
    { title: '' }
  ];

@Component({
  selector: 'app-salary',
  templateUrl: './salary.component.html',
  styleUrls: ['./salary.component.less']
})

export class SalaryComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  public headers = new HttpHeaders({
    "X-LoginAccessKey": localStorage.getItem("accessKey")
  });

  public Math = Math;

  // ローディング
  nowLoading = true;

  // 保存中
  isSaving = false;

  // ユーザー名
  userName = localStorage.getItem("userName") || localStorage.getItem("uid");

  // ユーザーID
  userId = localStorage.getItem("uid");

  // 切り替え
  tab = 1;

  // カラム名
  columns = col1;

  // 一覧
  list = [];

  // 祝日一覧
  holidays = [];

  // 一覧件数
  dataSourceLength = 0;

  // 清掃員名検索
  filterName = "";

  // 清掃員かな検索
  filterNameKana = "";

  // 清掃員コード
  filterStaffCd = null;

  // 物件名検索
  filterSite = "";

  // エリアリスト
  areas = [];

  // エリア検索
  areaIds = [];

  // 調整ステータスリスト
  adjustList = ['申請中', '差戻', '承認'];

  // 調整ステータス検索
  adjustStatus = [];

  // 相違あり検索
  isDiff: number = 0;

  // 確認済み検索
  isCheck: number = 0;

  // CSV出力検索
  isCSV: number = 0;

  // 給与奉行手入力検索
  isAffairs: number = 0;

  // 一覧の表示年月
  yearMonth = moment().add(-1, 'months').format('YYYY-MM');
  // yearMonth = moment().format('YYYY-MM');

  // ホバーした清掃員の行
  hoverGroup: number | null = null;

  // 承認待ち件数
  countPending = 0;

  // CSV出力権限
  csvAuth = localStorage.getItem("salaryCsv") === "true";

  // 承認権限
  auth = localStorage.getItem("salaryApprover") === "true";

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    const param = this.route.snapshot.paramMap.get('yearMonth');
    const staffCd = this.route.snapshot.paramMap.get('staffCd');

    // チャットワークから開いた場合
    if (param) {
      this.yearMonth = param
      if (staffCd) {
        if (staffCd == 'tab2') {
          this.tab = 2
        } else {
          this.filterStaffCd = staffCd
        }
      }
    } else {
      this.filterName =
        localStorage.getItem('search_staffs_name') != null ? localStorage.getItem('search_staffs_name') : "";
      this.filterNameKana =
        localStorage.getItem('search_staffs_nameKana') != null ? localStorage.getItem('search_staffs_nameKana') : "";
      this.adjustStatus =
        localStorage.getItem('adjustStatus') != null ? JSON.parse(localStorage.getItem('adjustStatus')) : [];
      this.filterStaffCd =
        Number(localStorage.getItem('filterStaffCd')) ? localStorage.getItem('filterStaffCd') : null;
      this.filterSite =
        localStorage.getItem('search_site_name') != null ? localStorage.getItem('search_site_name') : "";
      this.isDiff =
        Number(localStorage.getItem('isDiff')) ? Number(localStorage.getItem('isDiff')) : 0;
      this.isCheck =
        Number(localStorage.getItem('isCheck')) ? Number(localStorage.getItem('isCheck')) : 0;
      this.isCSV =
        Number(localStorage.getItem('isCSV')) ? Number(localStorage.getItem('isCSV')) : 0;
      this.isAffairs =
        Number(localStorage.getItem('isAffairs')) ? Number(localStorage.getItem('isAffairs')) : 0;
    }

    this.getHolidays();
  }

  /**
  * ページ読み込み後の初期化メソッド
  */
  async ngAfterViewInit() {

    // ユーザー設定 エリア検索あり
    const userArea = JSON.parse(localStorage.getItem('filterAreaSalary') || 'null');

    await this.getAreas(userArea);
    this.getData();

    this.paginator.page.subscribe(event => {
      this.list = []
      this.getData()
    });
  }

  /**
   * データ再取得
   */
  applyFilter() {
    this.paginator.pageIndex = 0;
    this.getData();
  }

  /**
   * 年月変更
   */
  changeYearMonth() {
    this.applyFilter();
    this.getHolidays();
  }

  /**
   * エリア、金額調整検索
   * @param opened 選択肢OPEN
   */
  onSelectOpened(opened: boolean) {
    // 閉じた瞬間だけ検索
    if (!opened) {
      this.applyFilter()
    }
  }

  /**
   * エリア全選択
   */
  selectAllAreas() {
    this.areaIds = this.areas.map(a => a.areaId);
  }

  /**
   * エリア全解除
   */
  clearAllAreas() {
    this.areaIds = [];
  }

  /**
   * 表示切り替え
   */
  changeTab() {
    this.list = []
    this.applyFilter();
    if (this.tab === 1) {
      this.columns = col1
    } else if (this.tab === 2) {
      this.columns = col2
    } else if (this.tab === 3) {
      this.columns = col3
    }
  }

  /**
  * 一覧を取得
  */
  getData() {
    if (!this.yearMonth) {
      alert('表示年月を入力してください')
      return
    }

    let filterStaffCd = this.filterStaffCd
    if (!filterStaffCd || isNaN(this.filterStaffCd)) {
      filterStaffCd = 0
    }

    this.nowLoading = true;

    // 給与一覧
    if (this.tab === 1) {
      this.getData1(filterStaffCd);
      this.countPendingApproval();
    // 承認待ち
    } else if (this.tab === 2) {
      this.getData2(filterStaffCd);
    // 調整履歴
    } else if (this.tab === 3) {
      this.getData2(filterStaffCd);
      this.countPendingApproval();
    }
  }

  /**
   * 給与一覧
   * @param filterStaffCd
   */
  getData1(filterStaffCd) {
    this.http.get(
      API_BASE_URL + '/api/v1/salary/getSalary?index='
        + this.paginator.pageIndex
        + "&size=" + this.paginator.pageSize
        + "&filterName=" + encodeURIComponent(this.filterName)
        + "&filterNameKana=" + encodeURIComponent(this.filterNameKana)
        + "&filterStaffCd=" + filterStaffCd
        + "&filterSite=" + encodeURIComponent(this.filterSite)
        + "&areaIds=" + this.areaIds
        + "&adjustStatus=" + this.adjustStatus
        + "&isDiff=" + this.isDiff
        + "&isCheck=" + this.isCheck
        + "&isCSV=" + this.isCSV
        + "&isAffairs=" + this.isAffairs
        + "&yearMonth=" + this.yearMonth,
      {headers: this.headers}
    )
    .subscribe((res: any[]) => {
      if (res && res.length > 0) {
        this.dataSourceLength = res[0].totalSize;
        // console.log(res)

        const list = []

        res.forEach((r, i) => {

          const before = res[i - 1]

          // rowspanのため、先頭行フラグを付ける
          const isFirst =
            i === 0 ||
            before.staffDailyCleaning !== r.staffDailyCleaning;

          r.isFirstRow = isFirst
          r.hourlyWageList = this.parseHourlyWages(r.hourlyWages)
          // リーダー手当の行（勤務金額だけ出す。日数・時間・有休・交通費の欄は空）
          r.isLeader = r.sequenceNumber == '-2'

          if (r.adjustStatus == '申請中') {
            r.color = 'blue'
          } else if (r.adjustStatus == '差戻') {
            r.color = 'red'
          }

          list.push(r)
        });
        this.list = list
        // console.log(this.list)
      } else {
        this.list = [];
        this.dataSourceLength = 0;
      }
      this.cdr.detectChanges();
      this.nowLoading = false;
      this.localStorageSet();
    },
    () => {
      alert("エラーが発生しました");
      this.router.navigate(['/']);
    });
  }

  /**
   * 承認待ち
   * @param filterStaffCd
   */
  getData2(filterStaffCd) {
    this.http.get(
      API_BASE_URL + '/api/v1/salary/getSalaryApproval?index='
        + this.paginator.pageIndex
        + "&size=" + this.paginator.pageSize
        + "&filterName=" + encodeURIComponent(this.filterName)
        + "&filterNameKana=" + encodeURIComponent(this.filterNameKana)
        + "&filterStaffCd=" + filterStaffCd
        + "&yearMonth=" + this.yearMonth
        + "&tab=" + this.tab,
      {headers: this.headers}
    )
    .subscribe((res: any[]) => {
      if (res && res.length > 0) {
        this.dataSourceLength = res[0].totalSize;

        const list = []

        res.forEach((r, i) => {

          const before = res[i - 1]

          // rowspanのため、先頭行フラグを付ける
          const isFirst =
            i === 0 ||
            before.staffDailyCleaning !== r.staffDailyCleaning;

          r.isFirstRow = isFirst
          r.hourlyWageList = this.parseHourlyWages(r.hourlyWages)
          r.isLeader = r.sequenceNumber == '-2'

          if (this.tab == 3) {
            if (r.adjustStatus == '承認') {
              r.color = 'green'
            } else if (r.adjustStatus == '申請中') {
              r.color = 'blue'
            } else {
              r.color = 'red'
            }
          }

          list.push(r)
        });
        this.list = list
      } else {
        this.list = [];
        this.dataSourceLength = 0;
      }

      if (this.tab == 2) {
        this.countPending = this.dataSourceLength;
      }

      this.cdr.detectChanges();
      this.nowLoading = false;
      this.localStorageSet();
    },
    () => {
      alert("エラーが発生しました");
      this.router.navigate(['/']);
    });
  }

  /**
   * 承認待ち件数
   */
  countPendingApproval() {
    this.http.get(
      API_BASE_URL + '/api/v1/salary/countPendingApproval?yearMonth=' + this.yearMonth,
      {headers: this.headers}
    )
    .subscribe((res: number) => {
      this.countPending = res
    },
    () => {
      alert("エラーが発生しました");
      this.router.navigate(['/']);
    });
  }

  /**
   * 金額調整中（申請中・差戻）の件数
   * @returns
   */
  async getPndAdjust(): Promise<any | null> {
    try {
      const res: any = await this.http.get(
        API_BASE_URL + "/api/v1/salary/getPndAdjust?"
          + "yearMonth=" + this.yearMonth,
        { headers: this.headers }
      ).toPromise();

      return res

    } catch (error) {
      console.log("金額調整中の件数を取得できませんでした");
      console.log(error);
      return null;
    }
  }

  /**
   * ローカルストレージにセット
   */
  localStorageSet() {
    localStorage.setItem('search_staffs_name', this.filterName);
    localStorage.setItem('search_staffs_nameKana', this.filterNameKana);
    localStorage.setItem('adjustStatus', JSON.stringify(this.adjustStatus));
    localStorage.setItem('filterStaffCd', this.filterStaffCd);
    localStorage.setItem('search_site_name', this.filterSite);
    localStorage.setItem('isDiff', String(this.isDiff != null ? this.isDiff : 0));
    localStorage.setItem('isCheck', String(this.isCheck != null ? this.isCheck : 0));
    localStorage.setItem('isCSV', String(this.isCSV != null ? this.isCSV : 0));
    localStorage.setItem('isAffairs', String(this.isAffairs != null ? this.isAffairs : 0));
  }

  /**
  * 祝日を取得
  */
  getHolidays() {
    if (!this.yearMonth) {
      return
    }
    this.holidays = [];

    this.http.get(
      API_BASE_URL + '/api/v1/nationalHoliday/getNationalHolidayByMonth?yearMonth='
        + this.yearMonth + '-01',
      {headers: this.headers}
    )
    .subscribe((res: any[]) => {
      if (res && res.length > 0) {
        this.holidays = res;
      }
    });
  }

  /**
   * 配列を変換
   * @param val
   * @returns
   */
  getArray(val, rep) {
    if (val) {
      return val.replace('{', '').replace('}', '').replace(/"/g, '').replace(/,/g, rep)
    }
    return val
  }

  /**
   * エリアのドロップダウン生成
   * @param userArea 個人設定されているユーザー用のエリア
   */
  async getAreas(userArea) {
    try {
      const res = await this.http.get(
        API_BASE_URL + "/api/v1/area?type=2",
        { headers: this.headers }
      ).toPromise();

      this.areas = res as any[];

      if (userArea && Array.isArray(userArea)) {
        // areas に存在する areaId のみ残す
        const areaIdSet = new Set(this.areas.map(a => a.areaId));
        this.areaIds = userArea.filter(id => areaIdSet.has(id));
      }

    } catch (e) {
      alert("エラーが発生しました");
      this.router.navigate(['/']);
    }
  }
  /**
   * 承認
   * @returns
   */
  approve(row, type) {
    if (['差戻'].includes(type) && !row.newNote) {
      if (!window.confirm('理由が記載されていませんがよろしいでしょうか？')) {
        return
      }
      row.newNote = ''
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "X-LoginAccessKey": localStorage.getItem("accessKey")
      })
    };

    this.nowLoading = true

    const time = moment().format('M/D HH:mm')


    // 過去の差戻理由と今回の差戻理由を合体
    if (row.newNote) {
      let note = row.newNote
      note += `\n　${type}：${this.userName || this.userId} （${time}）`

      if (row.rejectNote) {
        note += '\n\n'
      }

      row.rejectNote = '●' + note + (row.rejectNote || '')
    }

    // 過去の申請理由と今回の申請理由を合体
    if (row.applicantNote) {
      row.applicantNote += `\n　${row.applicantName || row.applicantId} （${moment(row.applicantDate).format('M/D HH:mm')}）`

      if (row.applicantOldNote) {
        row.applicantNote += '\n\n'
      }

      row.applicantOldNote = '●' + row.applicantNote + (row.applicantOldNote || '')
    }

    // 合計行を取得
    let totalRow = { ...row }
    if (!row.isTotal) {
      totalRow = this.list.find((v) => {
        return (v.staffDailyCleaning == row.staffDailyCleaning && v.isTotal)
      })

      totalRow.rejectNote = row.rejectNote
      totalRow.applicantOldNote = row.applicantOldNote
    }
    totalRow.adjustStatus = type
    totalRow.approverId = this.userId
    totalRow.approverName = this.userName || this.userId

    this.http.post(
        API_BASE_URL + '/api/v1/salary/approveSalaryAdjust',
          totalRow,
          httpOptions
      ).subscribe(res => {
        this.getData()
      },error => {
        alert("エラーが発生したため保存できませんでした。再度登録をお願いします。");
        console.log(error)
        this.getData()
      });
  }

  /**
   * その月に効いていた時給の並び（バックが返す JSON の文字列）を配列にする
   * @param hourlyWages [{"start_date":"2026-10-01","wage":1200}, ...] の文字列
   * @returns [{ startDate, wage }]（無ければ空）
   */
  parseHourlyWages(hourlyWages): { startDate: string, wage: number }[] {
    if (!hourlyWages) {
      return []
    }
    try {
      const list = JSON.parse(hourlyWages)
      return Array.isArray(list) ? list.map(w => ({ startDate: w.start_date, wage: w.wage })) : []
    } catch (e) {
      return []
    }
  }

  /**
   * 定期の警告の文言（行ごと。無ければ空）
   * ・定期があるのに、その月に通常勤務も本人の代勤も無い
   * ・勤務変更の変更元で、新しい契約にも定期がある（同じ月に定期が2つ）
   * @param row 行
   */
  fareMonthWarningText(row): string {
    if (row.isFareMonthWarning) {
      return 'この月の勤務なし'
    }
    if (row.isFareMonthChanged) {
      // 変更元の雇用指示の作業終了日を付ける（例：勤務変更前：～9/17）
      return '勤務変更前' + (row.endDayWork ? '：～' + row.endDayWork : '')
    }
    return ''
  }

  /**
   * 定期の警告がある行の「物件名（理由）」の一覧（金額OK の確認と、金額変更ダイアログの知らせに使う）
   * @param staffDailyCleaning 清掃員コード
   */
  fareMonthWarnings(staffDailyCleaning): string[] {
    return this.list
      .filter(v => v.staffDailyCleaning == staffDailyCleaning && (v.isFareMonthWarning || v.isFareMonthChanged))
      .map(v => String(v.nameSite || '').split('\n')[0] + '（' + this.fareMonthWarningText(v) + '）')
  }

  /**
   * チェックボックス変更
   * @param row
   */
  changeCheck(row, type) {
    // 金額OK を付けるとき、定期があるのにその月に勤務が無い行があれば知らせる（進めるかは利用者が決める）
    if (type === 'check' && row.isCheck) {
      const warnings = this.fareMonthWarnings(row.staffDailyCleaning)
      if (warnings.length) {
        const ok = window.confirm(
          '定期（1ヶ月の交通費）を確認してください。\n' +
          '　' + warnings.join('\n　') + '\n\n' +
          '交通費の金額はこのままでよいですか？\n（金額を変えるなら「キャンセル」を押して、金額変更から申請してください）'
        )
        if (!ok) {
          row.isCheck = false
          return
        }
      }
    }

    this.isSaving = true;

    // 日時
    const date = moment()
    // 値
    let check

    // 更新者
    if (type === 'diff') {
      row.isDiffUser = this.userName
      row.isDiffDate = date // 画面表示用
      check = row.isDiff
    } else if (type === 'check') {
      row.isCheckUser = this.userName
      row.isCheckDate = date // 画面表示用
      check = row.isCheck
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-LoginAccessKey': localStorage.getItem('accessKey')
      })
    };

    const data = this.list.filter((v) => {
      return v.staffDailyCleaning == row.staffDailyCleaning
    })

    this.http.post(
      API_BASE_URL + '/api/v1/salary/saveSalaryCheck?type=' + type
      + '&yearMonth=' + this.yearMonth
      + '&check=' + check
      + '&userName=' + this.userName
      + '&date=' + date
      + '&userId=' + this.userId
      , data
      , httpOptions
    ).subscribe(res => {
      this.isSaving = false;
    },error => {
      alert('保存できませんでした。再度お願いします。');
      this.isSaving = false;
    });
  }

  /**
   * CSV出力チェック削除
   * @param row
   */
  deleteCsv(row) {
    this.isSaving = true;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-LoginAccessKey': localStorage.getItem('accessKey')
      })
    };

    this.http.post(
      API_BASE_URL + '/api/v1/salary/deleteCsvCheck?yearMonth=' + this.yearMonth
      + '&userName=' + this.userName
      , row
      , httpOptions
    ).subscribe(res => {
      row.isCsv = false
      row.isCsvDate = null
      row.isCsvUser = null
      row.isAffairs = false
      row.isAffairsDate = null
      row.isAffairsUser = null
      this.isSaving = false;
    },error => {
      alert('保存できませんでした。画面リロード後、再度お願いします。');
      this.isSaving = false;
    });
  }

  /**
   * 給与一覧メモ保存
   * @param row
   */
  saveNote(row) {
    if (this.isSaving) {
      return
    }
    this.isSaving = true;

    // 年月
    row.yearMonth = this.yearMonth

    // 更新者
    row.updateUser = this.userName

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-LoginAccessKey': localStorage.getItem('accessKey')
      })
    };

    this.http.post(
      API_BASE_URL + '/api/v1/salary/saveSalaryNote'
      , row
      , httpOptions
    ).subscribe(res => {
      this.isSaving = false;
      row.newNoteChange = false;
    },error => {
      alert('保存できませんでした。再度お願いします。');
      this.isSaving = false;
    });
  }

  /**
   * CSV出力
   */
  async csv(isSalaryCsv) {
    // 給与奉行出力の場合は、警告する
    if (isSalaryCsv) {
      // 申請中、差戻があるか確認
      const pnd = await this.getPndAdjust()
      if (pnd && pnd.length) {
        const msg = pnd.map((p) => p.adjust_status + 'が' + p.cc + '件')

        if (!window.confirm(`${msg.join('、')} ありますがCSV出力してよろしいでしょうか？`)) {
          return
        }
      }
    }

    const dialogRef = this.dialog.open(SalaryCsvDialogComponent, {
      maxWidth: '95vw',
      data: {
        yearMonth: this.yearMonth,
        filterName: this.filterName,
        filterNameKana: this.filterNameKana,
        filterStaffCd: this.filterStaffCd,
        filterSite: this.filterSite,
        areas: this.areas,
        areaIds: this.areaIds,
        adjustStatus: this.adjustStatus,
        isDiff: this.isDiff,
        isCheck: this.isCheck,
        isCSV: this.isCSV,
        isAffairs: this.isAffairs,
        userId: this.userId,
        userName: this.userName,
        isSalaryCsv
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.getData()
      }
    });
  }

  /**
   * 詳細画面開く
   * @param row
   */
  openDetail(row) {
    this.dialog.open(SalaryDialogComponent, {
      maxWidth: '95vw',
      maxHeight: '98vh',
      data: { ...row, yearMonth: this.yearMonth, holidays: this.holidays }
    });
  }

  /**
   * 申請画面開く
   * @param row
   */
  openAppli(row) {
    let tar = { ...row }
    let saveData = []

    // 複数行ある場合
    if (!row.isTotal) {
      saveData = this.list.filter((l) => {
        return l.staffDailyCleaning == row.staffDailyCleaning
      })
      // 合計行を取得
      tar = saveData.find((l) => {
        return l.isTotal
      })
    } else {
      saveData = [tar]
    }

    const dialogRef = this.dialog.open(SalaryAdjustmentDialogComponent, {
      maxWidth: '95vw',
      maxHeight: '98vh',
      // fareMonthWarnings：定期があるのに、この月に勤務が無い契約の物件名（ダイアログの上に知らせを出す）
      data: { ...tar, saveData, yearMonth: this.yearMonth, userName: this.userName, fareMonthWarnings: this.fareMonthWarnings(row.staffDailyCleaning) }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.getData()
      }
    });
  }

  /**
   * 日数時間変更を開く
   * @param row
   */
  adjustDayHour(row) {
    let tar = { ...row }
    // 複数行ある場合
    if (!row.isTotal) {
      // 合計行を取得
      tar = this.list.find((l) => {
        return (l.staffDailyCleaning == row.staffDailyCleaning && l.isTotal)
      })
    }

    const dialogRef = this.dialog.open(SalaryAdjustmentDayHourDialogComponent, {
      maxWidth: '95vw',
      maxHeight: '98vh',
      data: { ...tar, yearMonth: this.yearMonth, userName: this.userName, staff: row.staff }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.getData()
      }
    });
  }

  /**
  * 清掃員名クリックイベント
  */
  staffDetailDialogOpen(event: any) {
    this.dialog.open(StaffDetailDialogComponent, {
      data: {
        data: event
      }
    });
  }
}
